export default "<h1 class=\"text-secondary\">Ops!</h1>\n<h4 class=\"text-primary\">Ocorreu um erro</h4>\n<h5>Tente novamente mais tarde</h5>";